import { fork } from 'redux-saga/effects';
import boostInitializationSaga from './boostInitializationSaga';

export default function* boostSagas() {
  yield fork(boostInitializationSaga);
}
